module.exports = __webpack_public_path__ + "static/img/cover.c4608845.jpg";